import { useContext } from 'use-context-selector';
import { AnalyticsContext } from 'Contexts/AnalyticsContext';

export default function useAnalytics() {
  return useContext(AnalyticsContext);
}
